import { get } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";

let permissionList = null;

export const initPermissions = () => {
  let stored = JSON.parse(localStorage.getItem("permissions")) ?? [];
  permissionList = new Set(stored);
};

export const checkPermission = (name) => {
  if (!permissionList) initPermissions();
  return permissionList.has(name);
};
export const getPermissions = async () => {
  const adminData = JSON.parse(localStorage.getItem("admin_details"));
  if (!adminData?.id) return;
  let res = await get(`${URLS.ADMINURL}${adminData?.id}/`);
  console.log("admin permission res", res);
  updatePermission(res?.permissions ?? []);
};

export const updatePermission = (permissions) => {
  permissionList = new Set(permissions);
};
